<script>
import { SocialSvg } from "./SocialIcon";
export default {
    props: {
        shop: {
            required: true,
            type: String
        },
        salePageId: {
            required: true
        },
        salePageBodyId: {
            required: false,
            type: Number
        }
    },
    data() {
        return {
            previewMode: false,
            loading: false,
            image: null,
            social_icons: SocialSvg,
            imageDir: "/linktree",
            form: {
                is_display_profile: true,
                name: "",
                description: "",
                image_profile: "",
                type: "column",
                button: [
                    {
                        title: "",
                        url: ""
                    }
                ],
                social_icons: []
            }
        };
    },
    methods: {
        async getData() {
            this.loading = true;
            if (this.salePageBodyId) {
                await axios
                    .get(`/linktree/${this.salePageBodyId}`)
                    .then(res => {
                        this.form = res.data.data;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.log(err.response.data);
                    });
            }
        },
        uploadImage() {
            document.getElementById("profile_image").click();
        },
        onFileChange(e) {
            this.loading = true;
            try {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    this.loading = false;
                    return;
                }
                const file_size = files[0].size / 1024 / 1024;
                const file_name = files[0].name;
                const re = /(\.jpg|\.jpeg|\.png)$/i;
                if (file_size > 2) {
                    this.messageAlert(
                        "error",
                        "ขนาดภาพใหญ่ไปนะ",
                        "TwT ขอโทษนะ กรุณาใช้ภาพขนาดไม่เกิน 2mb"
                    );
                    this.loading = false;
                } else if (!re.exec(file_name)) {
                    this.messageAlert(
                        "error",
                        "ไฟล์นี้ใช้ไม่ได้นะ",
                        "TwT ขอโทษนะ กรุณาใช้รูปภาพประเภท jpg, jpeg, png"
                    );
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.image = files[0];
                    this.previewImage(files[0]);
                }
            } catch (error) {
                this.loading = false;
            }
        },
        previewImage(file) {
            this.form.image_profile = URL.createObjectURL(file);
        },
        selectType(type) {
            this.form.type = type;
        },
        addLinkButton() {
            if (this.form.button.length < 6) {
                this.form.button.push({
                    title: "",
                    url: ""
                });
            } else {
                console.log("cannot add more than 6");
            }
        },
        addLinkSocialIcon(type) {
            if (this.form.social_icons.length < 6) {
                this.form.social_icons.push({
                    type: type,
                    url: ""
                });
            } else {
                console.log("cannot add more than 6");
            }
        },
        removeLinkButtonByIndex(index) {
            if (this.form.button.length > 1) {
                this.form.button.splice(index, 1);
            }
        },
        removeIconSocial(index) {
            this.form.social_icons.splice(index, 1);
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
        back() {
            let url = `/backend/s/${this.shop}/salepages/${this.salePageId}`;
            const { redirectUrl } = this.getQuery();
            if (redirectUrl) {
                url = redirectUrl;
            }
            window.location.href = url;
        },
        getQuery() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            return params;
        },
        chackValidate() {
            let isValid = true;
            if (
                this.form.is_display_profile &&
                (!this.form.name || !this.form.image_profile)
            ) {
                return false;
            }
            if (!this.form.social_icons.every(social => social.url)) {
                return false;
            }
            return this.form.button.every(button => button.title && button.url);
        },
        async handleSubmit() {
            if (this.salePageBodyId) {
                this.updated();
            } else {
                this.store();
            }
        },
        async updated() {
            this.loading = true;
            if (this.image) {
                const profileImage = await this.storeImage(this.image);
                this.form.image_profile = profileImage;
            }
            await axios
                .post(
                    `/backend/s/${this.shop}/salepages/${this.salePageId}/bodies/linktree/${this.salePageBodyId}`,
                    {
                        type: "linktree",
                        value: "",
                        form: this.form
                    }
                )
                .then(res => {
                    this.back();
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        async store() {
            this.loading = true;
            if (this.image) {
                const profileImage = await this.storeImage(this.image);
                this.form.image_profile = profileImage;
            }
            await axios
                .post(
                    `/backend/s/${this.shop}/salepages/${this.salePageId}/bodies/linktree`,
                    {
                        type: "linktree",
                        value: "",
                        form: this.form
                    }
                )
                .then(res => {
                    this.back();
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        async storeImage(imageFile) {
            let formData = new FormData();
            formData.append("image", imageFile ? imageFile : "");
            formData.append("imageDir", this.imageDir);

            const response = await axios
                .post(`/ajax/s/${this.shop}/upload-image`, formData)
                .then(res => {
                    const imageUrl = res.data.imageUrl;
                    return imageUrl;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "เกิดข้อผิดพลาด",
                        "กรุณาลองใหม่อีกครั้ง"
                    );
                });
            return response;
        }
    },
    mounted() {
        if (this.salePageBodyId) {
            this.getData();
        }
    }
};
</script>
<template>
    <div>
        <div
            class="tw-flex md:tw-flex-row tw-flex-col tw-w-full tw-py-5 tw-gap-5"
        >
            <loading-custom :loading="loading" />
            <div class="tw-flex-1">
                <div class="tw-text-xl tw-font-bold">
                    สร้าง Linktree ของคุณ
                </div>
                <div class="tw-mt-5" v-show="!previewMode">
                    <div
                        class="tw-border tw-rounded tw-border-solid tw-border-gray-200 tw-p-5 tw-mb-5"
                    >
                        <div class="tw-text-right tw-mb-5">
                            <label class="switch m-0">
                                <input
                                    type="checkbox"
                                    v-model="form.is_display_profile"
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <div class="form-group">
                            <label>ชื่อ</label>
                            <input
                                v-model="form.name"
                                type="text"
                                class="form-control"
                                placeholder="Profile name"
                            />
                        </div>
                        <div class="form-group">
                            <label>รายละเอียด</label>
                            <input
                                v-model="form.description"
                                type="text"
                                class="form-control"
                                placeholder="Profile description"
                            />
                        </div>
                        <div class="form-group">
                            <label>รูปภาพ</label>
                            <div
                                class="tw-flex tw-gap-5 sm:tw-flex-row tw-flex-col-reverse"
                            >
                                <img
                                    class="tw-w-full tw-h-auto sm:tw-w-40 sm:tw-h-40 tw-rounded"
                                    :src="
                                        ` ${form.image_profile ||
                                            '/images/placeholder/avatar.jpeg'}`
                                    "
                                    alt=""
                                />
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-default"
                                        @click="uploadImage"
                                    >
                                        อัพโหลดรูปภาพ
                                    </button>
                                    <input
                                        type="file"
                                        id="profile_image"
                                        class="sr-only"
                                        @change="onFileChange"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group tw-mt-10">
                        <label
                            >สร้างปุ่มเพื่อลิงค์ไปเว็บไซต์ที่คุณต้องการ
                            (สามารถใส่ได้สูงสุด 6 ลิงค์)</label
                        >
                        <div
                            v-for="(item, index) in form.button"
                            :key="index"
                            class="tw-flex tw-flex-row tw-border tw-rounded tw-border-solid tw-border-gray-200 tw-p-5 tw-mb-5 tw-items-center tw-pr-0"
                        >
                            <div class="tw-flex-col tw-flex tw-gap-4 tw-flex-1">
                                <div>
                                    <input
                                        v-model="item.title"
                                        type="text"
                                        class="form-control"
                                        placeholder="button name"
                                    />
                                </div>
                                <div>
                                    <input
                                        v-model="item.url"
                                        type="text"
                                        class="form-control"
                                        placeholder="https:example.com"
                                    />
                                </div>
                            </div>
                            <div
                                class="tw-w-10 tw-h-full tw-text-2xl tw-font-bold tw-flex tw-justify-center tw-items-center tw-cursor-pointer"
                                @click="removeLinkButtonByIndex(index)"
                            >
                                <div v-if="form.button.length > 1">
                                    X
                                </div>
                            </div>
                        </div>
                        <div class="mb-2">
                            <button
                                type="button"
                                class="tw-w-full tw-h-10 tw-text-center tw-border-none"
                                @click="addLinkButton()"
                            >
                                เพิ่มปุ่ม
                            </button>
                        </div>
                    </div>
                    <div class="form-group tw-mt-10">
                        <label>ประเภทการแสดงปุ่ม</label>
                        <div class="tw-flex tw-gap-4">
                            <div
                                :class="
                                    `${
                                        form.type == 'column'
                                            ? 'tw-bg-gray-600'
                                            : 'tw-bg-gray-400'
                                    } tw-w-28 tw-cursor-pointer tw-rounded tw-h-10 tw-items-center tw-flex tw-text-lg tw-font-bold tw-justify-center  tw-text-white`
                                "
                                @click="selectType('column')"
                            >
                                แสดงแนวตั้ง
                            </div>
                            <div
                                :class="
                                    `${
                                        form.type == 'row'
                                            ? 'tw-bg-gray-600'
                                            : 'tw-bg-gray-400'
                                    } tw-w-28 tw-cursor-pointer tw-rounded tw-h-10 tw-items-center tw-flex tw-text-lg tw-font-bold tw-justify-center tw-text-white`
                                "
                                @click="selectType('row')"
                            >
                                แสดงแนวนอน
                            </div>
                        </div>
                    </div>
                    <div class="form-group tw-mt-10">
                        <label
                            >เพิ่มโซเชียลเว็บไซต์
                            (กดที่ไอคอนเพื่อเพิ่มโซเชียลที่คุณต้องการได้ถึง 6
                            โซเชียล)</label
                        >

                        <div class="tw-flex tw-flex-col tw-gap-5 tw-mb-5">
                            <div v-for="(item, index) in form.social_icons">
                                <div class="tw-flex tw-justify-between">
                                    <div
                                        class="tw-flex tw-gap-3 tw-items-center tw-mb-3"
                                    >
                                        <div
                                            class="social_svg"
                                            v-html="social_icons[item.type]"
                                        ></div>
                                        <div class="tw-font-bold tw-text-xl">
                                            {{ item.type }}
                                        </div>
                                    </div>
                                    <div
                                        class="tw-font-bold tw-text-2xl tw-cursor-pointer"
                                        @click="removeIconSocial(index)"
                                    >
                                        x
                                    </div>
                                </div>
                                <input
                                    v-model="item.url"
                                    type="text"
                                    class="form-control"
                                    placeholder="https:example.com"
                                />
                            </div>
                        </div>
                        <div class="tw-flex tw-gap-3">
                            <div
                                class="tw-p-1 tw-border-4 tw-border-solid tw-border-gray-200 tw-rounded-full tw-cursor-pointer"
                                v-for="(key, index) in Object.keys(
                                    social_icons
                                )"
                                @click="addLinkSocialIcon(key)"
                            >
                                <div
                                    class="social_svg"
                                    v-html="social_icons[key]"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="sm:tw-hidden tw-w-full tw-py-5"
                    v-if="!!previewMode"
                >
                    <linktree-component v-bind="form" />
                </div>
                <div
                    class="sm:tw-hidden tw-flex tw-fixed tw-top-1/3 tw-right-0"
                >
                    <button
                        type="button"
                        :class="
                            `tw-border-none tw-rounded tw-h-10 tw-text-lg tw-bg-yellow-300 tw-px-2 tw-flex tw-justify-center tw-items-center`
                        "
                        @click="previewMode = !previewMode"
                    >
                        {{ !previewMode ? "ดูตัวอย่าง" : "แก้ไขข้อมูล" }}
                    </button>
                </div>
            </div>
            <div class="tw-flex-1 sm:tw-block tw-hidden">
                <!-- sticky -->
                <div class="sm:tw-sticky tw-top-24">
                    <linktree-component v-bind="form" />
                </div>
            </div>
        </div>
        <div class="tw-w-full text-right tw-mt-5">
            <button
                type="button"
                class="btn btn-sm btn-success"
                data-dismiss="modal"
                @click="handleSubmit()"
                :disabled="!chackValidate()"
            >
                บันทึก
            </button>
            <button
                type="button"
                class="btn btn-sm btn-default tw-ml-1"
                @click="back()"
            >
                ยกเลิก
            </button>
        </div>
    </div>
</template>
<style lang="scss">
.social_svg > svg {
    width: 32px;
    height: 32px;
}
</style>
<style scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 25px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: -2px;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .slider {
    background-color: #00b427;
}

input:focus + .slider {
    box-shadow: 0 0 1px #00b427;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
